import { render, staticRenderFns } from "./SelectTemplate.vue?vue&type=template&id=6f0b206d&scoped=true&"
import script from "./SelectTemplate.vue?vue&type=script&setup=true&lang=js&"
export * from "./SelectTemplate.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0b206d",
  null
  
)

export default component.exports